import { useCallback } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { fetchCurrentSeniorYear, selectCurrentSeniorYear } from '.'

// The current senior graduating class year, sourced from the backend
export const useCurrentSeniorYear = () => useSelector(selectCurrentSeniorYear)

export const useFetchCurrentSeniorYear = () => {
  const dispatch = useDispatch()
  return useCallback(() => dispatch(fetchCurrentSeniorYear()), [dispatch])
}
